import React from 'react';

export const LoadingCircular = () => {
  return(
    <div className="loading-circular">
      <div className="dot dot1"></div>
      <div className="dot dot2"></div>
      <div className="dot dot3"></div>
      <div className="dot dot4"></div>
    </div>
  );
};

export const LoadingLinear = () => {
  return(
    <div className="loading-linear">
      <div className="dot dot1"></div>
      <div className="dot dot2"></div>
      <div className="dot dot3"></div>
    </div>
  );
};
